import revenueProjection from './pcoCalculator'
import revenueProjectionKendoWindows from './revenue-projection-kendo-window'

export default function () {
    revenueProjection();
    revenueProjectionKendoWindows();
}
